import React, { useState } from 'react';

import { Grid, Select } from '@gogame/components';
import { FormField } from '@gogame/form';

import {
  DEPENDENCIES,
  FINISH_DATE,
  MAX_REDEMPTIONS_PER_USER,
  MULTI_REDEMPTION_COOLDOWN_PERIOD,
  START_DATE,
  USAGE_LIMIT,
} from 'scenes/PromoCodes/constants';
import { dateFNS } from '@gogame/intl-ts';

const DEACTIVATE_OPTIONS = [
  { id: 0, name: 'Usage limit' },
  { id: 1, name: 'Expiration date' },
];

const getDeactivateUponvalue = (values) => {
  if (!values || values.isSet) {
    return {};
  }
  return values.finishDate && !values[USAGE_LIMIT]
    ? DEACTIVATE_OPTIONS[1].id
    : DEACTIVATE_OPTIONS[0].id;
};

export const DeactivateUponSelect = ({ values, setValues }) => {
  const [deactivateUpon, setDeactivateUpon] = useState(
    !values.id ? DEACTIVATE_OPTIONS[1].id : getDeactivateUponvalue(values)
  );

  const handleChange = (_e, value) => {
    setValues({
      ...values,
      [USAGE_LIMIT]: undefined,
      [FINISH_DATE]: undefined,
    });

    setDeactivateUpon(value);
  };

  const handleValidateEndDate = (date) => {
    if (!date) {
      return 'Expiration date is required';
    }
  };

  const handleValidateLimit = (limit) => {
    if (!limit) {
      return 'Limit is required';
    }
  };

  return (
    <React.Fragment>
      <Grid item xs={3}>
        <Select
          label={'Deactivate upon'}
          options={DEACTIVATE_OPTIONS}
          padding={'0'}
          value={deactivateUpon}
          onChange={handleChange}
        />
      </Grid>
      {deactivateUpon === 0 && (
        <Grid item xs={3}>
          <FormField.TextField
            type={'number'}
            label={'Usage limit'}
            name={USAGE_LIMIT}
            helper={'0 - 1 000 000'}
            padding={'0'}
            required
            validate={handleValidateLimit}
          />
        </Grid>
      )}
      {deactivateUpon === 1 && (
        <Grid item xs={3}>
          <FormField.DatePicker
            label={'Expiration date'}
            padding={'0'}
            name={FINISH_DATE}
            required
            normalizeValue={normalizeExpirationDate}
            depends={DEPENDENCIES[FINISH_DATE]}
            source={emptySource}
            validate={handleValidateEndDate}
          />
        </Grid>
      )}
    </React.Fragment>
  );
};
function emptySource(params) {
  return params;
}
function normalizeExpirationDate(v, params) {
  const {
    [START_DATE]: startDate,
    [MULTI_REDEMPTION_COOLDOWN_PERIOD]: cooldownPeriod,
    [MAX_REDEMPTIONS_PER_USER]: maxRedemptionsPerUser,
  } = params;

  if (cooldownPeriod && maxRedemptionsPerUser) {
    // required fields are filled
    return dateFNS.addDays(
      new Date(startDate),
      cooldownPeriod * maxRedemptionsPerUser
    );
  }

  return v;
}
